module.exports = ".title {\n  margin-top: 20px;\n  text-align: center;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/video/list/show.component.less
// module id = ./src/app/video/list/show.component.less
// module chunks = main